module.exports = __webpack_public_path__ + "static/assets/9fc5a83c71695290c22d7636e7f4b90a.png";